import React from 'react';
import { useSelector } from 'react-redux';
// import { Spinner } from "@components/Spinner";
import { Spinner } from '@components/Spinner/SpinnerWithLessStyle';

const SpinnerScreen = () => {
  const { isLoading } = useSelector((state) => state.common);
  return <Spinner isLoading={isLoading} aligned fixed />;
};

export default SpinnerScreen;
